// import * as types from './mutation-types'

const mutations = {

  // 保存token
  setToken (state, data) {
    localStorage.setItem(`token`, data)
    state.token = data
  },

  // 退出登录
  Logout (state) {
    localStorage.clear()
    state.token = null
    state.userId = ''
    state.username = ''
    state.tokenExpiresAt = ''
    state.activeBot = 'null'
    state.hasGroupChatTodoDot = false
  },

  // 添加设置activeBot的mutation
  setActiveBot (state, data) {
    localStorage.setItem('activeBot', data)
    state.activeBot = data
  },

  // 保存userId
  // setUserId (state, data) {
  //   localStorage.setItem(`userId`, data)
  //   state.userId = data
  // },

  setUserInfo(state, data) {
    localStorage.setItem('token_expires_at', data.token_expires_at)
    localStorage.setItem('userId', data.user_id)
    localStorage.setItem('username', data.username)
    
    state.tokenExpiresAt = data.token_expires_at
    state.userId = data.user_id
    state.username = data.username
  },


  // 设置未读消息标志
  setHumanUnread(state, value) {
    state.hasHumanUnread = value
  },

  setGroupChatTodoDot(state, value) {
    state.hasGroupChatTodoDot = !!value
  },
  
}

export default mutations
